import React, { ReactNode, useEffect } from 'react';
import Loading from '../misc/Loading';
import Login from './Login';
import { silentAuth } from '../../store/AuthAction';
import { getMyModuleTypes } from '../../store/ModuleAction';
import StatusCode from '../../util/StatusCode';
import { useDispatch, useSelector } from 'react-redux';
import { MyModuleTypes } from '../../models/CoreDashboardModels';
import { FlowSyncAccessPolicy, isAuthorized } from '../../models/FlowSyncAccessPolicy';
import Forbidden from './Forbidden';
import Unauthorized from './Unauthorized';
import { RequestState } from '../../models/RequestState';
import { RootState } from '../../store/store';



interface PrivateProps {
    children: ReactNode[]
    accessPolicy?: FlowSyncAccessPolicy
}

const Private: React.FC<PrivateProps> = (props) => {
    const dispatch = useDispatch();

    const needLogin = useSelector<RootState, boolean>(state => state.auth.needLogin);
    const authorizationPolicies = useSelector<RootState, FlowSyncAccessPolicy[] | undefined>(state => state.auth.authorizationPolicies);
    const myModuleTypes = useSelector<RootState, RequestState<MyModuleTypes>>(state => state.module.myModuleTypes);

    useEffect(() => {
        if (authorizationPolicies === undefined) {
            silentAuth()(dispatch);
        }
        if (authorizationPolicies !== undefined && myModuleTypes.code === StatusCode.NONE) {
            getMyModuleTypes(true)(dispatch);
        }
    }, [dispatch, authorizationPolicies, myModuleTypes]);

    if (needLogin) {
        return <Login />;
    } else if (authorizationPolicies === undefined || (myModuleTypes.code === StatusCode.NONE || myModuleTypes.code === StatusCode.PENDING)) {
        return <Loading style={{ padding: '40px' }} />;
    } else if (!isAuthorized(authorizationPolicies, FlowSyncAccessPolicy.READ_OVERVIEW)) {
        return <Unauthorized />
    } else if (props.accessPolicy && !isAuthorized(authorizationPolicies, props.accessPolicy)) {
        return <Forbidden />
    }

    return <>{props.children}</>
}

export default Private;
